import { Heading2, Heading3 } from '@blueprint/heading';
import { Link } from '@blueprint/link';
import { CardContainer, ArticleSnippetText } from './cms-article-card.styles';
import { ArticleCardProps } from './cms-article-card.types';
import { ArticlePublishedTime } from './ArticlePublishedTime';
import { articleTracking } from './cms-article-card.tracking';
import { CmsImage } from '@zoopla/cms/image';

function CmsArticleCard({
    article,
    index = 0,
    headingLevel = 'h2',
    linesToTruncate = 2,
    horizontalLayout = false,
    heroArticle = false,
    trackingFunction
}: ArticleCardProps) {
    const Heading = headingLevel === 'h2' ? Heading2 : Heading3;

    const classNames = `${horizontalLayout ? 'horizontal' : ''} ${
        heroArticle ? 'heroArticle' : ''
    }`;

    return (
        <CardContainer
            data-testid={`recent-article-container-${index}`}
            className={classNames}
            heroArticle={heroArticle}
        >
            <CmsImage
                data-testid={`recent-article-image-${index}`}
                src={`${article.heroImage?.url}`}
                width={800}
                loading="lazy"
                alt=""
            />
            <div className="article-card__info">
                <Heading size="6">
                    <Link
                        href={`/discover/${article?.category?.slug ?? ''}/${
                            article?.slug
                        }/`}
                        data-testid={`recent-article-link-${index}`}
                        onClick={() =>
                            trackingFunction
                                ? trackingFunction()
                                : articleTracking(
                                      article?.slug ?? '',
                                      article?.category?.slug ?? '',
                                      index
                                  )
                        }
                        plain
                    >
                        {article.title}
                    </Link>
                </Heading>
                <ArticlePublishedTime
                    dateTime={article.publicationDateAndTime}
                />
                <ArticleSnippetText lines={linesToTruncate}>
                    {article.snippet}
                </ArticleSnippetText>
            </div>
        </CardContainer>
    );
}

export default CmsArticleCard;
